// extracted by mini-css-extract-plugin
module.exports = {"Projects":"ProjectStyle_Projects__2hw0r","Cards":"ProjectStyle_Cards__24DAh"};